<template>
  <div class="run_build_list">
    <div class="build_ol">
      <div class="build_li">
        <router-link to="/my/NotAudit" replace>
          <div>
            <span>待审核</span>
          </div>
        </router-link>
      </div>
      <div class="build_li">
        <router-link to="/my/AlreadAudit" replace>
          <div>
            <span>已通过</span>
          </div>
        </router-link>
      </div>
      <div class="build_li">
        <router-link to="/my/RefuseAudit" replace>
          <div>
            <span>未通过</span>
          </div>
        </router-link>
      </div>
    </div>
    <!--显示子路由内容部分-->
    <router-view></router-view>
  </div>
</template>
<style lang="scss" scoped>
  .run_build_list {
    width: 100%;
    padding-top: 40px;
    .build_ol {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #d7d7d7;
      list-style: none;
      background: #fff;
      right: 0;
      left: 0;
      position: fixed;
      z-index: 666;
      .build_li {
        width: 32.2%;
        // width: 48.5%;
        float: left;
        height: 50px;
        text-align: center;
        margin-left: 2px;
        border-right: 1px solid #d7d7d7;
        a {
          width: 100%;
          color: #0C7AD9;
          font-size: 15px;
          text-align: center;
          text-decoration: none;
          div {
            height: 48px;
            span {
              line-height: 50px;
              font-weight: normal;
            }
          }
        }
        a.active {
          color: #0C7AD9;
          font-size: 15px;
          text-align: center;
          div {
            border-bottom: 3px solid #2585d0;
            span{
              font-weight: bolder;
            }
          }
        }
      }
      .build_li:first-child {
        border-left: none;
      }
      .build_li:last-child {
        border-right: none;
      }
    }
  }
</style>
<script>
  export default {
    name: 'HomeAduit',
    data () {
      return {}
    },
    created () {},
    components: {},
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/my/homeAudit/HomeAduit.vue